import { useEffect, useState } from 'react';
import Link from 'next/link';

import { humanizeMonetaryValue } from '../../../util';

const RecentJobs = ({ number = 3 }) => {
  const [recentJobs, setRecentJobs] = useState([]);

  useEffect(() => {
    async function fetchRecent() {
      const url = `/api/jobs/recent-jobs/recent-job-postings-by-lat-lng-header`;
      const response = await fetch(url);
      const data = await response.json();
      setRecentJobs(data.body.results.slice(0, number));
    }

    fetchRecent();
  }, [number]);

  return (
    <div className="row">
      {recentJobs.map((job, key) => {
        return (
          <div className={`col-sm-${12 / number} mb-3`} key={key}>
            <Link href={job.url} passHref>
              <a className="cta-card" href={job.url}>
                <span className="title">{job.title}</span>
                <span className="company">{job.company}</span>
                <span className="location">
                  <i className="fa-solid fa-location-dot"></i>
                  {job.location}
                </span>
                <Compensation job={job} />
              </a>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

const Compensation = ({ job }) => {
  if (typeof job.baseSalary !== 'object') {
    return <></>;
  }

  const { minValue, maxValue, currency, unitText } = job.baseSalary;

  if (!(minValue && maxValue && currency && unitText)) {
    return <></>;
  }

  return (
    <span className="salary">
      {unitText === 'YEAR' ? 'Salary Range' : 'Compensation'}:{' '}
      <span className="salary-range-bottom">{humanizeMonetaryValue(currency, minValue, 0)}</span>{' '}
      &ndash;{' '}
      <span className="salary-range-top">
        {humanizeMonetaryValue(currency, maxValue, 0)}
        <UnitText text={unitText} />
      </span>
    </span>
  );
};

const UnitText = ({ text }) => {
  let formatted = '';

  if (['MONTH', 'WEEK', 'DAY', 'HOUR', 'CONTRACT'].includes(text)) {
    formatted = ` per ${text.toLowerCase()}`;
  }

  return <>{formatted}</>;
};

module.exports = RecentJobs;
